import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { CircularProgress } from '@material-ui/core';
import { useRevisionHistoryActions as useActions } from '../../hooks/useRevisionHistoryActions';
import {
  // revisionHistorySelector,
  revisionHistoryInteralSelector,
} from '../../selectors/revisionHistory';
import SummaryListing from './summaryListing';
import DetailChangeLog from './detailChangeLog';
import { getImmutableData } from '../../utils';
import { fetchingState } from '@constants';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';

export const OBJECT_TYPES = {
  PROPERTY: 'pID',
  OWNER: 'ownerID',
  AGENT: 'agentID',
  TAXING_UNIT: 'taxingUnitID',
  BUILDING_PERMIT: 'buildingPermitID',
  BUILDER_PLAN: 'builderPlanID',
  DEED: 'deedID',
  SALE: 'saleID',
  MORTGAGELENDER: 'mortgagelenderId',
  ARBITRATION: 'arbitrationID',
  LITIGATION: 'caseID',
};

const RevisionHistory = ({ objectType, objectId, needRefresh }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [selectedId, setSelectedId] = useState();
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [filter, setFilter] = useState('');
  //const revisionHistory = useSelector(revisionHistorySelector);
  const revisionHistoryInternal = useSelector(revisionHistoryInteralSelector);
  const revisionHistoryData = getImmutableData(revisionHistoryInternal, []);
  const recordCount =
    revisionHistoryInternal && revisionHistoryInternal.get('count');
  const {
    // searchRevisionHistory,
    searchRevisionHistoryInternal,
  } = useActions([]);

  const setSelectedIdAndIndex = async (id) => {
    if (!id) {
      setCurrentIndex(-1);
      return;
    }
    const revisionRecordIndex = !revisionHistoryData
      ? []
      : revisionHistoryData.findIndex(
          i => i && i.revisionHistoryID === id,);
    setCurrentIndex(revisionRecordIndex);
  };

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? revisionHistoryData.length - 1 : prevIndex - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex === revisionHistoryData.length - 1 ? 0 : prevIndex + 1));
  };

  useEffect(() => {
    if (currentIndex === -1) {
      setSelectedId(null);
      return;
    }
    const item = revisionHistoryData[currentIndex];
    if (!item) return;
    setSelectedId(item.revisionHistoryID);
  }, [currentIndex, setSelectedId])

  useEffect(() => {
    // searchRevisionHistory({
    //   from: page * rowsPerPage,
    //   size: rowsPerPage,
    //   query: {
    //     bool: {
    //       must: [
    //         {
    //           term: {
    //             [objectType]: objectId,
    //           },
    //         },
    //       ],
    //     },
    //   },
    // });
    if (objectType && objectId) {
      searchRevisionHistoryInternal({
        page: page + 1,
        size: rowsPerPage,
        data: {
          [objectType]: objectId,
        },
      });
    }
  }, [page, rowsPerPage, needRefresh]);

  return (
    <Container>
      {revisionHistoryInternal.get('state') === fetchingState.FETCHING && (
        <div style={{ textAlign: 'center' }}>
          <CircularProgress />
        </div>
      )}
      {}
      {revisionHistoryInternal.get('state') === fetchingState.LOADED &&
        !selectedId && (
          <SummaryListing
            revisionHistory={revisionHistoryData}
            setId={setSelectedIdAndIndex}
            recordCount={recordCount}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            filter={filter}
            setFilter={setFilter}
          />
        )}
      {selectedId && (
        <>
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
            style={{ marginLeft: 20 }}
          >
            <Link
              to="#"
              style={{ textDecoration: 'underline' }}
              onClick={() => setSelectedIdAndIndex(null)}
            >
              Revision History
            </Link>
            <Typography color="textPrimary">{selectedId}</Typography>
          </Breadcrumbs>
          <DetailChangeLog
            revisionHistory={revisionHistoryData}
            selectedId={selectedId}
            handlePrevious={handlePrevious}
            handleNext={handleNext}
            onClose={() => setSelectedIdAndIndex(null)}
          />
        </>
      )}
    </Container>
  );
};

RevisionHistory.propTypes = {
  objectType: PropTypes.string.isRequired,
  objectId: PropTypes.number.isRequired,
  needRefresh: PropTypes.any,
};

const Container = styled.div`
  background-color: #fff;
  min-height: 500px;
`;

export default RevisionHistory;
